import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GlobalService } from 'src/app/app-core/lib/global.service';
import { MenuService } from 'src/app/app-core/services/menu.service';
import { UserService } from 'src/app/app-core/services/user.service';
import { UserSessionService } from 'src/app/app-core/services/user-session.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    providers: [MenuService, UserService],
})
export class SidebarComponent implements OnInit, OnDestroy {
    public menuItems: any[];
    public isCollapsed = true;
    public skeletonCount = Array.from({ length: 8 });

    private perfilAlteradoSub: Subscription;

    constructor(
        public global: GlobalService,
        public menu: MenuService,
        public router: Router,
        public userService: UserService,
        private userSession: UserSessionService,
    ) {}

    ngOnInit() {
        this.carregarMenu();

        // A sidebar fica fora do router-outlet, então navegar não a recria. Sem ouvir a troca
        // de perfil, ela continuaria exibindo o menu do grupo anterior.
        this.perfilAlteradoSub = this.userSession.perfilAlterado$.subscribe(() => {
            this.carregarMenu();
        });
    }

    ngOnDestroy() {
        this.perfilAlteradoSub?.unsubscribe();
    }

    private carregarMenu() {
        if (this.userService.isCidadao()) {
            this.menuItems = [];
            return;
        }

        this.menu.sideMenu(this.global.user().USR_CodigoUsuario).subscribe({
            next: (response: any) => {
                this.menuItems = response.map((menu) => this.mapToArgon(menu));
                if (this.userService.isTriagem()) {
                    this.addRequestsAllTopLevelMenu();
                }
            },
        });
    }


    private addRequestsAllTopLevelMenu() {
        if (!this.menuItems) return;

        const hasRequestsAll = this.menuItems.some((item) => item && item.url === '/requests/all');

        if (!hasRequestsAll) {
            const isTriagem = this.userService.isTriagem();
            const tipoProcessoAceito = this.global.user().DEP_TipoProcessoAceito;
            const aceitaExterno = tipoProcessoAceito === 1 || tipoProcessoAceito === 3;

            if ((isTriagem) && aceitaExterno) {
                this.menuItems.unshift({
                    url: '/requests/all',
                    name: 'Todas as Solicitações',
                    icon: 'ph-list',
                    children: [],
                });
            }
        }
    }

    public mapToArgon(menu) {
        if (menu) {
            return {
                url: menu.url,
                name: menu.name,
                icon: menu.icon,
                children: menu.children.map((m) => this.mapToArgon(m)),
            };
        }

        return null;
    }
}
